/*
 * @description: 个人中心混入对象
 * @Author: wxy
 * @Date: 2019-03-18 15:30:53
 */
import { mapGetters } from 'vuex'
import { getScore } from '@/api/community'
import { communityType } from './dictionary'

const communityMixin = {
  computed: {
    ...mapGetters(['userInfo']),
    $_communityMixin_userInfo () {
      return this.userInfo
    },
    $_communityMixin_employeeNo () {
      return this.userInfo.employeeNo
    },
    $_communityMixin_isManager () {
      if (this.userInfo.roleName.indexOf('社区管理员') !== -1) {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    $_communityMixin_successMessage (isMobile, msg) {
      if (isMobile) {
        this.$toast({
          type: 'success',
          message: msg,
          duration: 1000
        })
      } else {
        this.$message({
          type: 'success',
          message: msg
        })
      }
    },
    $_communityMixin_warnMessage (isMobile, msg) {
      if (isMobile) {
        this.$toast.fail(msg)
      } else {
        this.$message({
          type: 'warning',
          message: msg
        })
      }
    },
    $_communityMixin_toHomePage (isMobile) {
      if (isMobile) {
        this.$router.push('/mobile/community/list')
      } else {
        this.$router.push('/community/list')
      }
    },
    $_communityMixin_getUserScore () {
      let reward = ''
      getScore({
        id: this.$_communityMixin_employeeNo
      }).then(res => {
        if (res.data.code === '200') {
          reward = res.data.data.amount
          document.getElementById('community-user-score').innerHTML(reward)
        }
      })
    },
    $_communityMixin_changeSore (type) {
      this.$emit('changeScore')
    }
  }
}

export { communityMixin }



// WEBPACK FOOTER //
// ./src/views/community/utils/communityMixin.js